module.exports = __webpack_public_path__ + "img/tasas-leche.72dedb69.jpeg";